import { render, staticRenderFns } from "./ExcludeArea.vue?vue&type=template&id=7ef816f6"
import script from "./ExcludeArea.vue?vue&type=script&lang=ts"
export * from "./ExcludeArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports